module.exports = function getResource(label, vars = []) {
    let resources = {
        selectProduct: 'Select your current product for'
    };

    return resources[label];
};
